import { array, struct, union } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';
import { Id as ParameterId } from '../../../../whole-house/additional-parameter/Id';
import { ParameterRef } from '../../../../whole-house/additional-parameter/ParameterRef';

export const Request = union(
	struct({
		parameterRefs: array(ParameterRef),
		organizationId: OrganizationId,
	}),
	struct({
		parameterIds: array(ParameterId),
		organizationId: OrganizationId,
	})
);
